import { pages } from '@/services/Api'
import { core } from '@/services/ApiCore'
import browserHelper from '@/helpers/browserHelper'

export default {
  getFile() {
    return pages.post('/graphql', {
      query: `
        query {
          assets(page: $id) {
            name
            path
            size
            type
            url
          }
        }
      `,
      variables: {
        id: browserHelper.getPageId(),
      },
    })
  },

  upload(asset) {
    const data = new FormData()
    data.append(
      'operations',
      JSON.stringify({
        query: `
        mutation($page: ID!, $asset: Upload!) {
          uploadAsset(page: $page, asset: $asset) {
            name
            path
            size
            type
            url
          }
        }
      `,
        variables: {
          page: browserHelper.getPageId(),
          asset: null,
        },
      })
    )

    data.append(
      'map',
      JSON.stringify({
        '0': ['variables.asset'],
      })
    )
    data.append('0', asset)

    return pages.post('/graphql', data)
  },

  uploadCore(asset) {
    const data = new FormData()
    data.append('file', asset)

    return core.post(`/api/pages_editor/upload_assets/${browserHelper.getPageId()}`, data)
  },
}
